export const POSITION_LOADING = "POSITION_LOADING";
export const GET_STRUCTURE = "GET_STRUCTURE";
export const POSITION_RESET = "POSITION_RESET";
export const GET_STRUCURE = "GET_POSITION";
export const GET_POSITION = "GET_POSITION";
export const GET_POSITION_SUCCESS = "GET_POSITION_SUCCESS";
export const GET_POSITION_FAIL = "GET_POSITION_FAIL";
export const DELETE_POSITION = "DELETE_POSITION"
export const DELETE_POSITION_SUCCESS = "DELETE_POSITION_SUCCESS"
export const DELETE_POSITION_FAIL = "DELETE_POSITION_FAIL"
export const UPDATE_POSITION = "UPDATE_POSITION"
export const UPDATE_POSITION_SUCCESS = "UPDATE_POSITION_SUCCESS"
export const UPDATE_POSITION_FAIL = "UPDATE_POSITION_FAIL"
export const ADD_NEW_POSITION = "ADD_NEW_POSITION"
export const ADD_POSITION_SUCCESS = "ADD_POSITION_SUCCESS"
export const ADD_POSITION_FAIL = "ADD_POSITION_FAIL"